<template>
  <div class="section-wrapper student-quiz-history">
    <h2 class="section-title">
      {{
        $t("student.quiz history title", {
          user: studentName
        })
      }}
    </h2>
    <div v-if="!classroom.loading && classroom.data">
      <van-collapse
        v-model="activeBoxes"
        v-for="(box, index) in boxes"
        :key="`box-${index}`"
      >
        <van-collapse-item
          :name="index"
          :disabled="getQuizHistory(box.id).length <= 0"
        >
          <template #title>
            <h3 class="box-title">{{ box.name }}</h3>
          </template>
          <template #icon><i class="fas fa-box"></i></template>
          <template #value> x {{ getQuizHistory(box.id).length }}</template>
          <BoxQuizHistory
            :quizHistory="getQuizHistory(box.id)"
            :fancy="false"
          />
          <!--
          <BoxWordStatisticsQuizChart
            v-if="Object.keys(getQuizHistory(box.id)).length > 0"
            :quizResults="getQuizHistory(box.id)"
            :cards="box.cards"
          /> 
          <span class="no-data" v-else>{{
            $t("stats.box quiz data not available")
          }}</span>
          -->
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import BoxQuizHistory from "@/components/BoxQuizHistory";

export default {
  name: "StudentQuizHistory",
  components: {
    BoxQuizHistory
  },
  data() {
    return {
      studentId: -1,
      classroomId: -1,
      activeBoxes: []
    };
  },
  methods: {
    ...mapActions("vokabel", ["getClassroom"]),
    getQuizHistory(boxId) {
      const all =
        this.classroomData && this.classroomData["quiz_result_stats"]
          ? this.classroomData["quiz_result_stats"]
          : [];
      const result = all.filter(stat => {
        return stat.user.id == this.studentId && stat.box == boxId;
      });
      return result;
    }
  },
  computed: {
    ...mapState("vokabel", ["classroom"]),
    ...mapGetters("vokabel", ["getUsername"]),
    classroomData() {
      const { classroom } = this;
      return classroom.data ? classroom.data : {};
    },
    boxes() {
      return this.classroomData && this.classroomData.boxes_list
        ? this.classroomData.boxes_list
        : [];
    },
    studentName() {
      let name = this.getUsername(
        this.studentId,
        this.classroomData ? this.classroomData.members_list : []
      );
      return name;
    }
  },
  mounted() {
    this.studentId = this.$route.params.student_id;
    this.classroomId = this.$route.params.classroom_id;
    this.getClassroom(this.classroomId);
  }
};
</script>

<style lang="scss">
.box-title {
  margin-left: 14px;
}
</style>
